export default {
  agencyFilterLabel: "Filter by agency",
  industryFilterLabel: "Filter by industry",
  subindustryFilterLabel: "Filter by Sub-Industry",
  agency: "Agency",
  user: "User",
  role: "Role",
  advertiser: "Advertiser",
  addNewLabel: (label: string): string => `Add New ${label}`,
  accountFilterLabel: "Filter by account",
  all: "All",
  accountLabel: "Account",
  accountsLabel: "Accounts",
  businessGoal: "Business Goal",
  bgNamePlaceholder: "Campaign ID | Business Goal",
  b2bb2c: "B2B/B2C",
  gender: "Demo Gender",
  ageGroup: "Demo Age Group",
  pixelExperience: "Pixeling Experience",
  websiteConversion: "Website Conversion Experience",
  averageOrderValue: "Average Order Value",
  brandRecognition: "Brand Recognition",
  timeToConversion: "Estimated Time to Conversion",
  audienceSize: "Estimated Audience Size",
  chartType: "Chart Type",
  chartTitleLabel: "Chart Title",
  countryFilterLabel: "Filter by country",
  categoryLabel: "Category Label",
  date: "Date",
  owner: "Owner",
  editor: "Editor",
  viewer: "Viewer",
  displayNameLabel: "Display Name",
  decompositionMetric: "Decomposition Metric",
  defaultNewPageName: "New Page",
  defaultNewPlanName: "New Plan",
  emailAddressLabel: "Email Address",
  industry: "Industry",
  projectDetails: "Project Details",
  businessGoalDetails: "Business Goal Details",
  items: "Items",
  subIndustry: "Sub-Industry",
  url: "URL",
  project: "Project",
  nameDashboard: "Name your dashboard",
  namePlan: "Name your Plan",
  nameScenario: "Name your Scenario",
  scenarioDetails: "Scenario Details",
  impressions: "Impressions",
  landingPageVisits: "Landing Page Visits",
  search: "Search",
  scenarioGranularity: "Time Granularity",
  summaryTitleLabel: "Summary Title",
  icons: "Icons",
  legend: "Legend",
  tableTitleLable: "Table Title",
  roleFilterLabel: "Filter by role",
  nullValues: "NULL values",
  targetValue: "Target Value",
  view: "View",
  countSelected: (count: number): string => `${count} selected`,
};
